var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"completed-badge badge badge--solid",class:{
		'badge--medium text-regular space-children-inline-regular': !_vm.isReduced,
		'badge--small text-medium space-children-inline-tight': _vm.isReduced,
	}},[_c('span',[_vm._v(_vm._s(_vm.$t('completed')))]),_c('success-checkmark',{class:{
			'text-large': !_vm.isReduced,
			'text-regular': _vm.isReduced,
		}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }